module.exports = __webpack_public_path__ + "img/JAB HOUSE-W.e20a6515.png";